import { type ReactNode } from "react";
import CarHeader from "./CarHeader";
import { useTheme } from "@/context/ThemeContext";
import { useIsMobile } from "@/hooks/use-mobile";
import { useNativePlatform } from "@/hooks/useNativePlatform";
import { useShowNavigateBack } from "@/hooks/useShowNavigateBack";
import { cn } from "@/lib/utils";

interface CarListingLayoutProps {
  type: string | undefined;
  children: ReactNode;
}

const CarListingLayout = ({ type, children }: CarListingLayoutProps) => {
  const { theme } = useTheme();
  const isDark = theme === "dark";
  const isMobile = useIsMobile();
  const { isNative } = useNativePlatform();
  const showPageBack = useShowNavigateBack();

  return (
    <div
      className={`min-h-screen ${isNative ? "native-listing-page " : ""}${
        isDark ? "text-white bg-black/95" : "text-gray-800 bg-white"
      }`}
    >
      <div
        className={cn(
          "container max-w-6xl py-0 md:py-8 animate-fade-in relative",
          isNative ? "px-0" : "px-4",
        )}
      >
        {showPageBack && isMobile && <CarHeader type={type} />}
        {showPageBack && !isNative && !isMobile && (
          <div className="mb-4 xl:mb-0 xl:absolute xl:left-4 xl:-translate-x-full xl:pr-4">
            <CarHeader type={type} />
          </div>
        )}
        <div className="w-full">{children}</div>
      </div>
    </div>
  );
};

export default CarListingLayout;
